import { Navigate, Outlet } from "react-router-dom";

export default function Authed() {
    const token = localStorage.getItem("access_token")
    if (token === null) return <Navigate to="/login" />
    return <Outlet />;
}
